"use strict";
import createClasses from "./createClasses";
import geoStore from "../stores/geoStore";
import pointStore from "../stores/pointStore";
import configStore from "../stores/configStore";
import dropdownFilterStore from "../stores/dropdownFilterStore";
import { meetings as meetingDetails, fallback as fallbackDetails } from "./DrawerDetail";
import L from "../leaflet";
const createSkeletonItem = () => L.DomUtil.create("li", "decidimGeo__drawer__listCard");
export default class Drawer {
  constructor(parent) {
    this.cardList = null;
    this.loadingDOM = null;
    this.parent = parent;
  }
  isEmpty() {
    return false;
  }
  loadingDom() {
    if (this._loadingDOM) return this._loadingDOM;
    this._loadingDOM = L.DomUtil.create(
      "div",
      createClasses("decidimGeo__drawer__listCardLoader")
    );
    this._loadingDOM.appendChild(createSkeletonItem());
    this._loadingDOM.appendChild(createSkeletonItem());
    this._loadingDOM.appendChild(createSkeletonItem());
    return this._loadingDOM;
  }
  repaintList(points) {
    points.map((point) => {
      this.cardList.appendChild(point.menuItem);
    });
  }
  repaintEmpty() {
    const i18n = this.i18n();
    const emptyContainer = L.DomUtil.create(
      "li",
      "decidimGeo__emptyDrawer__container",
      this.cardList
    );
    const emptyParagraph = L.DomUtil.create(
      "p",
      "decidimGeo__emptyDrawer__paragraph",
      emptyContainer
    );
    emptyParagraph.textContent = i18n["decidim_geo.filters.empty.message"];
    const emptyAction = L.DomUtil.create(
      "button",
      "decidimGeo__emptyDrawer__button",
      emptyContainer
    );
    emptyAction.textContent = i18n["decidim_geo.filters.empty.update_button"];
    emptyAction.onclick = this.emptyActionHandler.bind(this);
  }
  config() {
    return configStore.getState();
  }
  i18n() {
    return this.config().i18n;
  }
  filters() {
    return this.config().filters || [];
  }
  hasAssemblyOrProcess() {
    return this.filters().some((f) => f.assembly_filter || f.process_filter);
  }
  emptyActionHandler() {
    const { open } = dropdownFilterStore.getState();
    open();
  }
  repaintLoading() {
    const loadingElement = this.loadingDom();
    this.cardList.appendChild(loadingElement);
  }
  repaintDetail({ data: node }) {
    var _a, _b, _c;
    const listCard = L.DomUtil.create(
      "li",
      "decidimGeo__drawer__listCard",
      this.cardList
    );
    listCard.onclick = (evt) => {
      var _a2, _b2;
      evt.stopPropagation();
      let node_url = "";
      if (this.hasAssemblyOrProcess()) {
        node_url = node.resourceUrl;
      } else {
        node_url = (_b2 = (_a2 = node == null ? void 0 : node.extendedData) == null ? void 0 : _a2.componentUrl) != null ? _b2 : node.resourceUrl;
      }
      if (node_url == null ? void 0 : node_url.startsWith("https://")) {
        window.open(node_url, "_blank", "noopener,noreferrer");
      } else {
        location.href = node_url;
      }
    };
    const { images } = configStore.getState();
    const GeoEncodedIcon = L.DomUtil.create(
      "img",
      createClasses("decidimGeo__drawer__listCardIcon"),
      listCard
    );
    GeoEncodedIcon.src = images == null ? void 0 : images.geolocated;
    if (!node.lonlat) {
      GeoEncodedIcon.style.opacity = "0.32";
    }
    const info = L.DomUtil.create(
      "div",
      "decidimGeo__drawer__listCardInfo decidimGeo__drawer__listCardInfo--large",
      listCard
    );
    switch (node.resourceType) {
      case "meetings":
        meetingDetails(info, node);
        break;
      default:
        fallbackDetails(info, node);
        break;
    }
    const viewBtn = L.DomUtil.create("a", "decidimGeo__drawer__viewBtn", info);
    viewBtn.textContent = this.i18n()["decidim_geo.actions.view"];
    if (this.hasAssemblyOrProcess()) {
      viewBtn.href = node.resourceUrl;
    } else {
      viewBtn.href = (_b = (_a = node == null ? void 0 : node.extendedData) == null ? void 0 : _a.componentUrl) != null ? _b : node.resourceUrl;
    }
    if ((_c = viewBtn.href) == null ? void 0 : _c.startsWith("https://")) {
      viewBtn.setAttribute("target", "_blank");
    }
    this.cardList.scrollTo({ top: 0 });
    return listCard;
  }
  repaint() {
    L.DomUtil.empty(this.cardList);
    const { loading, getFilteredPoints } = pointStore.getState();
    const { selectedPoint } = geoStore.getState();
    const pointsInMap = getFilteredPoints();
    if (loading()) {
      return this.repaintLoading();
    }
    if (selectedPoint) {
      return this.repaintDetail(selectedPoint);
    }
    if (pointsInMap.length === 0) {
      this.repaintEmpty();
    } else {
      this.repaintList(pointsInMap);
    }
    this.cardList.className = createClasses("decidimGeo__drawer__list", [
      loading() && "loading",
      this.isEmpty() && "empty"
    ]);
  }
  onAdd() {
    if (!this.parent) throw new Error("no this.parent ");
    const { loading } = pointStore.getState();
    this.cardList = L.DomUtil.create(
      "ul",
      createClasses("decidimGeo__drawer__list", [
        loading() && "loading",
        this.isEmpty() && "empty"
      ]),
      this.parent
    );
    L.DomEvent.disableClickPropagation(this.cardList);
    L.DomEvent.disableScrollPropagation(this.cardList);
    geoStore.subscribe(
      (state) => [state.selectedPoint, state.selectedScope],
      () => {
        this.repaint();
      }
    );
    pointStore.subscribe(
      (state) => [state.isLoading, state.loading, state._lastResponse, state._lastFilter],
      ([_isLoading, loading2]) => {
        if (loading2()) return;
        this.repaint();
      }
    );
    this.repaint();
    return this.cardList;
  }
}
